







































import mixins from 'vue-typed-mixins';
import debounce from 'lodash.debounce';
import LogUtils, { Log } from '@/utils/LogUtils';
import { DataTableHeader } from 'vuetify';
export default mixins().extend({
  computed: {
    headers(): DataTableHeader<Log>[] {
      return [
        {
          text: this.$i18n.tc('app.label.action'),
          value: 'action',
        },
        {
          text: this.$i18n.tc('model.common.date'),
          value: 'date',
        },
        {
          text: this.$i18n.tc('model.user.username'),
          value: 'user.name',
        },
        {
          text: this.$i18n.tc('model.serviceProvider.label'),
          value: 'serviceprovider.name',
        },
        {
          text: this.$i18n.tc('model.survey.label'),
          value: 'survey.name.admin',
        },
        {
          text: this.$i18n.tc('model.question.label'),
          value: 'question.name',
        },
      ];
    },
  },

  data(): {
    logs?: Log[];
    total?: number;
    loading: boolean;
    search: {
      serviceProvider?: string;
      username?: string;
      startdate?: string;
      enddate?: string;
    };
    options: any;
  } {
    return {
      logs: undefined,
      total: undefined,
      loading: true,
      search: {
        serviceProvider: undefined,
        username: undefined,
        startdate: undefined,
        enddate: undefined,
      },
      options: {},
    };
  },

  created() {
    (this as any).debouncedLoad = debounce(this.load, 500);
  },

  watch: {
    options: {
      async handler() {
        await (this as any).debouncedLoad();
      },
      deep: true,
    },
    search: {
      async handler() {
        await (this as any).debouncedLoad();
      },
      deep: true,
    },
  },

  methods: {
    async load() {
      try {
        this.loading = true;
        /**
         * this.options =
         * page: number
         * itemsPerPage: number
         * sortBy: string[]
         * sortDesc: boolean[]
         * groupBy: string[]
         * groupDesc: boolean[]
         * mustSort: boolean
         * multiSort: boolean
         */
        const resp = await LogUtils.api.instance.list({
          serviceprovidername: this.search.serviceProvider,
          username: this.search.username,
          startdate: this.search.startdate,
          enddate: this.search.enddate,
          tableParams: this.options,
        });
        this.logs = resp.result;
        this.total = resp.count;
        this.loading = false;
      } catch (error) {
        this.$alert.show('load', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
    async edit(log: Log) {
      await this.$router.push({
        name: 'logs-edit',
        params: { id: `${log.id}` },
      });
    },
  },
});
